import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ListItem as OriListItem } from 'appkit-react';
import { Menu, Dropdown, Tooltip } from 'antd';
// import '@style/components/projectCard.scss';
import '../../styles/components/projectCard.scss';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

import Avatar from './Avartar';
import { ActionBtn } from '../index';
import { Tag } from '@components';
import alert from '@components/alert';
import { API } from '@service';
import actions from '@flux/action';
import { formatUserLocalDate } from '@utils/widget';
import ProjectTag from '@components/projectCard/Tag';
import { useCurrentUserPermission } from 'src/hooks/useCurrentUserPermission';
import { projectRole } from '@model';
import useHideProjectDetail from '@hooks/useHideProjectDetail';

const getProjectLabel = (isBuyer) => (label, instanceType) => {
  if (label) {
    return label;
  }
  //WARNING: companyInstance can be ['Divestiture', 'Integration', null]
  if (instanceType === 'Divestiture') {
    return isBuyer ? 'RemainCo' : 'Seller';
  }
  return isBuyer ? 'Buyer' : 'Target';
};

const getBuyerLabel = getProjectLabel(true);
const getTargetLabel = getProjectLabel(false);

function ListItem(props) {
  // const history = useHistory();
  const { data, onClick, settingClick, onDelete, onPin, userPreference } =
    props;
  const {
    projectName,
    targetIndustry,
    buyerIndustry,
    buyerName,
    targetName,
    manager_name,
    lead_name,
    projectId,
    createdAt,
    pinned = false,
    createdBy,
    isSingleCompany,
    buyerLabel,
    targetLabel,
    companyInstance,
    instanceName,
    instanceType,
    instanceIsDeleted,
  } = data;
  const userInfo = useSelector((state) => state.login.userInfo);
  const isInternal = JSON.parse(
    window.localStorage.userInfo || '{}',
  ).isInternal;
  const [swrProjectId, setSwrProjectId] = useState(null);
  const { projectBasicInfo } = useCurrentUserPermission(swrProjectId);
  const isContributor =
    projectBasicInfo?.currentUserPermission === projectRole.Contributor;
  const { shouldShowDetail } = userPreference;

  // const { value: shouldShowDetail } = useHideProjectDetail();

  const dispatch = useDispatch();

  const onDeleteConfirm = async (close) => {
    close();
    dispatch(actions.changeLoading(true));
    await API.deleteProject(projectId);
    dispatch(actions.changeLoading(false));
    onDelete(projectId);
  };

  const onArchiveConfirm = async (close) => {
    close();
    dispatch(actions.changeLoading(true));
    await API.archiveProject(projectId);
    dispatch(actions.changeLoading(false));
    onDelete(projectId);
  };

  const menu = (
    <Menu
      style={{
        marginTop: '1rem',
        background: 'var(--selectDropdownBg)',
        width: '5.625rem',
      }}
    >
      {isInternal && isContributor && (
        <Menu.Item key="0" className="role-control">
          <a
            onClick={(e) => {
              e.stopPropagation();
              settingClick({ projectName, currentId: projectId });
            }}
          >
            Settings
          </a>
        </Menu.Item>
      )}

      <Menu.Item key="1">
        <a
          onClick={() => {
            onPin(projectId);
          }}
        >
          {pinned ? 'Unpin' : 'Pin'}
        </a>
      </Menu.Item>
      {userInfo.isAdmin && isInternal && (
        <Menu.Item key="2" className="role-control">
          <a
            onClick={() => {
              alert.confirm({
                content: 'Do you want to archive this project?',
                okText: 'yes',
                onOk: onArchiveConfirm,
              });
            }}
          >
            Archive
          </a>
        </Menu.Item>
      )}
      {isInternal && isContributor && (
        <Menu.Item key="3" className="role-control">
          <a
            onClick={() => {
              alert.confirm({
                content: 'Do you want to delete this project?',
                okText: 'delete',
                onOk: onDeleteConfirm,
              });
            }}
          >
            Delete
          </a>
        </Menu.Item>
      )}
    </Menu>
  );

  const handleClick = (e) => {
    onClick && onClick(data, e);
  };

  const formatStringToEDTTimeStr = (dateStr, createdBy) => {
    if (isNaN(new Date(dateStr).valueOf())) {
      return '';
    }
    const formattedDateStr = formatUserLocalDate(dateStr);
    const creatorStr = createdBy ? `by ${createdBy} ` : '';
    return (
      <>
        Created {creatorStr}
        <p>{formattedDateStr}</p>
      </>
    );
  };

  const onActionBtnMouseEnter = () => {
    if (isInternal) {
      setSwrProjectId(projectId);
    }
  };

  return (
    <NavLink
      to={`/project-detail/${projectId}`}
      onClick={(e) => e.preventDefault()}
    >
      <OriListItem className="project-card-wrapper" onClick={handleClick}>
        {pinned ? <span className="appkiticon icon-pin" /> : <div />}
        <div className="content">
          <div className="name-tag">
            <div className="project-name">{projectName}</div>
            {/*{shouldShowDetail ? (*/}
            {/*  <ProjectTag*/}
            {/*    companyInstance={companyInstance}*/}
            {/*    type={instanceName}*/}
            {/*    shouldHide={instanceIsDeleted}*/}
            {/*  />*/}
            {/*) : null}*/}
          </div>
          <div className="setting-wrapper" onClick={(e) => e.stopPropagation()}>
            <Dropdown
              placement="bottomRight"
              overlay={menu}
              trigger={['click']}
              getPopupContainer={() => document.querySelector('.app-container')}
            >
              <a
                className="ant-dropdown-link"
                onClick={(e) => e.preventDefault()}
              >
                <ActionBtn onMouseEnter={onActionBtnMouseEnter} />
              </a>
            </Dropdown>
          </div>
        </div>
        {shouldShowDetail ? (
          <>
            <div className="divider" />

            <div className="content content-bottom">
              <div className="owner-wrapper">
                <div>
                  <Avatar name={lead_name} title="Engagement Lead" />
                  {isInternal && (
                    <div className="create-at">
                      {formatStringToEDTTimeStr(createdAt, createdBy)}
                    </div>
                  )}
                </div>
                <div>
                  <Avatar name={manager_name} title="Engagement Manager" />
                </div>
              </div>
              <div className="subinfo-wrapper">
                <div className="info">
                  <div className="title">
                    {getBuyerLabel(buyerLabel, instanceType)}
                  </div>
                  {data.confidential ? (
                    <div>Confidential</div>
                  ) : (
                    <div>
                      <Tooltip
                        title={buyerName || '-'}
                        placement="topLeft"
                        overlayClassName="project-list-tip-fit"
                      >
                        <div className="text text-wrap">{buyerName || '-'}</div>
                      </Tooltip>
                      {buyerIndustry && (
                        <Tooltip
                          title={buyerIndustry || ''}
                          placement="topLeft"
                          overlayClassName="project-list-tip-fit"
                        >
                          <Tag className="text">{buyerIndustry}</Tag>
                        </Tooltip>
                      )}
                    </div>
                  )}
                </div>

                <div className="info">
                  {!isSingleCompany && (
                    <>
                      <div className="title">
                        {getTargetLabel(targetLabel, instanceType)}
                      </div>
                      {data.confidential ? (
                        <div>Confidential</div>
                      ) : (
                        <div>
                          <Tooltip
                            title={targetName || '-'}
                            placement="topLeft"
                            overlayClassName="project-list-tip-fit"
                          >
                            <div className="text text-wrap">
                              {targetName || '-'}
                            </div>
                          </Tooltip>
                          {targetIndustry && (
                            <Tooltip
                              title={targetIndustry || ''}
                              placement="topLeft"
                              overlayClassName="project-list-tip-fit"
                            >
                              <Tag className="text">{targetIndustry}</Tag>
                            </Tooltip>
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </>
        ) : isInternal ? (
          <div className="content hidden-detail">
            <div className="owner-wrapper">
              <div className="create-at">
                {formatStringToEDTTimeStr(createdAt, createdBy)}
              </div>
            </div>
          </div>
        ) : null}
      </OriListItem>
    </NavLink>
  );
}

ListItem.propTypes = {
  data: PropTypes.object.isRequired,
};

const mapStateToProps = ({ projects }) => ({
  userPreference: projects.userPreference,
});

export default connect(mapStateToProps)(React.memo(ListItem));
